<template>
  <div class="collection-filters" v-if="currentFilters && currentFilters.length">
    <div class="collection-filters__active-filters">
      <div
        class="collection-filters__active-filter"
        v-for="(filter, index) in currentFilters"
        :key="`filter_${index}`"
        @click="removeFilter(filter)"
      >
        <span>{{unhandleizeFilter(filter)}}</span>
        <div>
          <icon name="close" size="10px"></icon>
        </div>
      </div>
    </div>
    <div class="collection-filters__filters-clear">
      <a
        href="#"
        v-if="currentFilters.length"
        class="link-text"
        :primary="true"
        @click.prevent="removeAllFilters"
      >Clear All</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { unhandleize } from '@/scripts/filters/string.js';

import Icon from '../basic/Icon.vue';
import VLink from '../buttons/VLink.vue';

export default {
  name: 'CollectionActiveFiltersB',
  components: { Icon, VLink },
  computed: {
    ...mapState({
      currentFilters: (state) => state.collections.currentFilters,
    }),
  },
  methods: {
    unhandleizeFilter(handleizedFilter) {
      // .replace first space with ': ' for display purposes.
      return unhandleize(handleizedFilter).replace(' ', ': ');
    },
    removeFilter(filter) {
      this.$store.dispatch('collections/updateFilters', this.currentFilters.filter(fil => fil !== filter));
    },
    removeAllFilters() {
      const newCurrentFilters = [];
      this.$store.dispatch('collections/updateFilters', newCurrentFilters);
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-filters {
  display: flex;
  align-items: center;
  margin-right: 15px;
  @include mobile-tablet {
    padding: 16px 16px 24px;
    margin-bottom: 0;
    flex-direction: column;
  }
  &__title {
    font-weight: bold;
    font-family: $font-family-secondary;
    margin-right: 8px;
    font-size: 14px;
    line-height: 24px;
  }
  &__active-filters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 10px;
  }
  &__active-filter {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 0;
    color: $color-black-700;
    background-color: $color-black-100;
    transition: border-color 200ms ease;
    margin-right: 10px;
    min-height: 35px;
    font-size: 13px;
    margin-bottom: 10px;
    &:hover {
      border-color: $color-brand-primary;
    }
    &:active {
      border-color: darken($color: $color-brand-primary, $amount: 20);
    }
    span {
      margin-right: 8px;
    }
  }
  &__filters-clear {
    @include mobile-tablet {
      margin-top: 8px;
    }

    a {
      white-space: nowrap;
    }
  }
}
</style>
